
/**
 * Extracts the country name from a comma-separated address string.
 * It assumes the country is the final element in the string.
 *
 * @param {string} addressString - The address string (e.g., "Brugg, Aargau, Switzerland").
 * @returns {string|null} The cleaned country name, or null if the input is invalid.
 */
export const getCountryFromAddress = (addressString) => {
    if (!addressString || typeof addressString !== 'string') {
        return null;
    }
    const parts = addressString.split(',');
    if (parts.length === 0) {
        return null;
    }
    const country = parts[parts.length - 1].trim();
    return country;
}